// extracted by mini-css-extract-plugin
module.exports = {"ScoreHeader":"ScoreHeader_ScoreHeader__1VBsN"};